import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import CreditCard from "@mui/icons-material/CreditCard";
import DocumentIcon from "@mui/icons-material/Description";
import NotesIcon from "@mui/icons-material/Assignment";
import WorkIcon from "@mui/icons-material/Work";
import MainPageIcon from "@mui/icons-material/Home";
import TrainingIcon from "@mui/icons-material/School";
import GppGoodIcon from '@mui/icons-material/GppGood';
import PlumbingIcon from '@mui/icons-material/Plumbing';
import BuildIcon from '@mui/icons-material/Build';
import React from "react";

export const MAIN_MENU_ITEMS = [
    {
        label: 'Main',
        featureKey: 'frontend_main',
        icon: <MainPageIcon fontSize="small" />,
        link: '/main',
    },
    {
        label: 'Operations',
        icon: <WorkIcon fontSize="small" />,
        subMenu: [
            { label: 'Daily Log', featureKey: 'frontend_daily_log', link: '/daily-log' },
            { label: 'Incidents', featureKey: 'frontend_incidents', link: '/incidents' },
            { label: 'Hold Harmless Form', featureKey: 'frontend_hold_harmless', link: '/temps/exhibit-b' },
            { label: 'Post-Work Area Turnover', featureKey: 'post_work_area_turnover', link: '/forms/post-work-area-turnover/list' },
            { label: 'Employee Warning Notice', featureKey: 'frontend_employee_warning', link: '/forms/employee-warning-notice/list' },
            { label: 'Welder Qualification & Release', featureKey: 'frontend_welder_qualification_release', link: '/operations/welder-qualification-release' },
            { label: 'Lift Evaluation Form', featureKey: 'frontend_lift_evaluation', link: '/operations/lift-evaluation' },
            { label: 'Lift Truck PM Inspection', featureKey: 'frontend_lift_truck_pm', link: '/operations/lift-truck-pm' },
        ],
    },
    {
        label: 'Tools & Equipment',
        icon: <BuildIcon fontSize="small" />,
        subMenu: [
            { label: 'Equipment Inspection', featureKey: 'frontend_ext_equipment', link: '/operations/ext-equipment/scan' },
            { label: 'Gas Monitor Test', featureKey: 'frontend_gas_monitor_test', link: '/operations/gas-monitor-test' },
            { label: 'Equipment List', featureKey: 'equipment_list', link: '/operations/equipment-list' },
        ],
    },
    {
        label: 'Administration',
        icon: <AdminPanelSettingsIcon fontSize="small" />,
        subMenu: [
            {
                label: 'Synchronization',
                featureKey: 'frontend_synchronization',
                link: '/admin/synchronization',
            },
            {
                label: 'Weekly Roster',
                featureKey: 'frontend_weekly_roster',
                link: '/admin/weekly-employee',
            },
        ],
    },
    {
        label: 'TBT',
        featureKey: 'tool_box_talk',
        icon: <DocumentIcon fontSize="small" />,
        subMenu: [
            { label: 'TBT', featureKey: 'tool_box_talk', link: '/tbt' },
            { label: 'Create new TBT', featureKey: 'tool_box_talk', link: '/tbt/add' },
        ],
    },
    {
        label: 'Training',
        icon: <TrainingIcon fontSize="small" />,
        subMenu: [
            { label: 'Training Due', featureKey: 'training_form', link: '/training-due' },
            { label: 'MEWPS Proficiency', featureKey: 'frontend_practical_evaluation', link: '/training-due/practical-evaluation' },
            { label: 'Forklift Proficiency', featureKey: 'frontend_forklift_proficiency', link: '/training-due/forklift-proficiency' },
            { label: 'Training Sessions (Demo)', featureKey: 'frontend_training_sessions', link: '/training-sessions' },
        ],
    },
    {
        label: 'CC',
        featureKey: 'frontend_cc',
        icon: <CreditCard fontSize="small" />,
        link: '/cc',
    },
    {
        label: 'PO',
        featureKey: 'frontend_po',
        icon: <NotesIcon fontSize="small" />,
        link: '/po',
    },
    {
        label: 'Safety Stand Down',
        featureKey: 'safety_stand_down',
        icon: <GppGoodIcon fontSize="small" />,
        link: '/ssd',
    },
    {
        label: 'Piping',
        icon: <PlumbingIcon fontSize="small" />,
        subMenu: [
            { label: 'Piping Information', featureKey: 'frontend_piping_torque', link: '/piping/information' },
            { label: 'Piping Forms', featureKey: 'pipe_hydro_test', link: '/piping/forms' },
        ],
    },
    {
        label: 'Safety',
        icon: <GppGoodIcon fontSize="small" />,
        subMenu: [
            { label: 'Confined Space Entry Permit', featureKey: 'confined_space_entry_permit', link: '/csep' },
            { label: 'Lock-Tag-Try Checklist (<600V)', featureKey: 'lock_tag_try_permit', link: '/ltt' },
            { label: 'Aerial/Scissor Lift Operator', featureKey: 'frontend_aerial_scissor', link: '/safety/forms/aerial-scissor-lift-operator' },
            { label: 'Fall Arrest Rescue Plan', featureKey: 'frontend_fall_arrest_rescue_plan', link: '/safety/forms/fall-arrest-rescue-plan' },
            { label: 'Safety Data Sheets (SDS)', featureKey: 'sds', link: '/sds' },
        ],
    },

];
